import { useState } from "react";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import ArticleCard from "@/components/feature/ArticleCard";

const tags = [
  "路透",
  "直播",
  "争议",
  "结局",
  "同框",
  "红毯",
  "现场",
  "暖心",
  "奇闻",
  "带货",
];

export default function LatestFeed() {
  const [active, setActive] = useState("all");

  const list =
    active === "all" ? articles : articles.filter((item) => item.categorySlug === active);

  const recommended = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 4);

  return (
    <section className="bg-background-100 px-4 py-10 md:px-8 md:py-14">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
            最新事件流
          </h2>
          <p className="mt-1.5 text-sm font-label text-foreground-500">
            按更新时间倒序排列，切换主题即可只看你关心的那一类。
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => setActive("all")}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-label transition-colors ${
              active === "all"
                ? "bg-primary-500 text-background-50"
                : "bg-background-50 text-foreground-600 hover:bg-background-200"
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat.slug}
              type="button"
              onClick={() => setActive(cat.slug)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-label transition-colors ${
                active === cat.slug
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-4">
        <div className="lg:col-span-3">
          {list.length ? (
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
              {list.slice(0, 6).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <p className="rounded-lg border border-background-200 bg-background-50 px-5 py-10 text-center text-sm font-label text-foreground-500">
              这个分类暂时还没有新的整理内容，换一个主题看看吧。
            </p>
          )}
          <div className="mt-6 flex justify-center">
            <Link
              to={active === "all" ? "/hot" : `/category/${active}`}
              className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看该主题全部事件
            </Link>
          </div>
        </div>

        <aside className="flex flex-col gap-5">
          <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-bookmark-3-line text-accent-600"></i>
              编辑推荐
            </h3>
            <div className="mt-3 flex flex-col gap-3">
              {recommended.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group flex gap-3"
                >
                  <span className="relative h-14 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
                    <img
                      src={article.cover}
                      alt={`${article.title} 推荐配图`}
                      title={`${article.title} 52吃瓜网`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="line-clamp-2 text-sm font-label text-foreground-800 transition-colors group-hover:text-primary-700">
                      {article.title}
                    </span>
                    <span className="mt-1 block text-xs font-label text-foreground-400">
                      {article.heat}万热度
                    </span>
                  </span>
                </Link>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-price-tag-3-line text-secondary-600"></i>
              热门标签
            </h3>
            <div className="mt-3 flex flex-wrap gap-2">
              {tags.map((tag) => (
                <span
                  key={tag}
                  className="cursor-pointer rounded-full bg-background-100 px-3 py-1 text-xs font-label text-foreground-600 transition-colors hover:bg-accent-100 hover:text-accent-900"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-primary-200 bg-primary-50 p-4 md:p-5">
            <h3 className="font-heading text-base font-bold text-primary-800">
              手里有线索？
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-primary-900/80 font-label">
              把你看到的情况和来源告诉我们，我们会先做基础核实，再决定是否整理成事件记录。
            </p>
            <Link
              to="/contact"
              className="mt-4 inline-flex whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
            >
              提交线索
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}